export const TRACKING_SESSION_ID_NAME = 'tracking_sid';
export const COOKIE_DOMAIN = process.env.NEXT_PUBLIC_COOKIE_DOMAIN || '';

/** Endpoint documentation here: https://track.staging.test.bestjobs.eu/docs#/default/track_events_event_post */
export const EVENTS_TRACKING_URL = process.env.NEXT_PUBLIC_EVENTS_TRACKING_URL || '';
